<template>
  <div>
    <div class="cart">
      <div class="c-title">{{langCart.cart}}</div>
      <i @click="cartHandle" class="iconfont icon-cuowu"></i>
    </div>
    <div class="items">
      <!-- <div class="item" v-for="(item, index) in cart" :key="index">
        <div class="p-img" v-if="item.goodsId===1">
          <img class="product-img" :src="pictures[item.goodsId]" />
          <i class="iconfont icon-plus"></i>
          <img class="product-img tow-img" src="@/assets/images/zhijiatow.png" alt />
        </div>
        <div class="p-img" v-else>
          <img
            :class="{'zhijia-img':item.goodsId===7}"
            class="product-img fix-img"
            :src="pictures[item.goodsId]"
          />
        </div>
        <div class="taocan">
          <div>{{cameraName[item.goodsId]}}</div>
          <ul>
            <li v-for="(item,i) in detail[item.goodsId]" :key="i">{{item}}</li>
          </ul>
          <div class="numAP-con">
            <div class="numAP">
              <i :class="{fobid:item.goodsCount<=1}" @click="reduce(item)">-</i>
              <span>{{item.goodsCount}}</span>
              <i @click="add(item)">+</i>
            </div>
            <div v-if="cannotdel['id']===item.goodsId&&cannotdel['status']" class="error-txt">
              <span>至少要购买1件</span>
            </div>
          </div>
        </div>
        <div class="jiage">
          <div class="jg-price">￥{{item.price}}</div>
          <div class="oper">
            <span @click="rmItem(item)">移除</span>
          </div>
        </div>
      </div> -->
      <div class="p-info" v-for="(item,i) in cart" :key="i">
          <div class="p-img">
            <div class="pi-con">
              <img :src="pictures[item.goodsId]">
            </div>
          </div>
          <div class="p-params">
            <h3>{{cameraName[item.goodsId]}}</h3>
            <ul>
              <li v-for="(sub,i) in detail[item.goodsId]" :key="i">
                <span>{{sub}}</span>
                <span style="margin-left:5px;">x{{item.goodsCount}}</span>
              </li>
            </ul>
          </div>
          <div>
            <div class="numAP">
              <i :class="{fobid:item.goodsCount<=1}" @click="reduce(item)">-</i>
              <span>{{item.goodsCount}}</span>
              <i @click="add(item)">+</i>
            </div>
            <div v-if="cannotdel['id']===item.goodsId&&cannotdel['status']" class="error-txt"><span>至少要购买1件</span></div>
          </div>
          <div class="oper">
            <span @click="rmItem(item)">移除</span>
          </div>
          <div class="p-price"><span>￥ {{item.price*item.goodsCount}}</span></div>
        </div>
      <div v-if="cart.length<=0" class="no-cart">
        <img :src="`${$cdn}images/no-cart.png`" alt />
        <p v-html="langCart.nothing"></p>
        <div @click="toEight" class="c-button purchase">{{langCart.shop}}</div>
      </div>
    </div>
    <div v-if="cart.length>0" class="jiesuan">
      <p>共计{{getSum()[0]}}件套装</p>
      <div class="price">￥{{getSum()[1]}}</div>
      <div class="btns">
        <div class="c-button" @click="toPay">
          <vcenter>
            <img :src="`${$cdn}images/product_icon_arrow.png`" alt />
          </vcenter>
        </div>
        <div @click="toPay" class="c-button purchase">立即结算</div>
      </div>
    </div>
  </div>
</template>

<script>
import vcenter from '@/components/vcenter'
import { mapState } from 'vuex'
let cameraName = {
  7: `四维看看 三脚架套装`,
  1: `四维看看 Lite二目相机`,
  4: `四维看看 Pro八目相机`
}

let cameraNameEn = {
  7: `4D KanKan Pro Tripod Set`,
  1: `四维看看 Lite二目相机`,
  4: `4DKanKan Pro Camera`
}
let detail = {
  7: ['四维看看 三脚架套装(标准色)'],
  1: [
    '四维看看 Lite二目相机(静谧黑)',
    '容量套餐(5G)',
    '四维看看 Lite专用三脚架(标准色)'
  ],
  4: ['四维看看 Pro八目相机(静谧黑)', '容量套餐(10G)']
}
let detailEn = {
  7: ['4D KanKan Pro Tripod Set (Standard)'],
  1: [
    '四维看看 Lite二目相机(静谧黑)',
    '容量套餐(5G)',
    '四维看看 Lite专用三脚架(标准色)'
  ],
  4: ['4DKanKan Pro Camera (Night Sky Black)', 'Storage Plan (10G)']
}
export default {
  computed: {
    ...mapState({
      token: state => state.user.token,
      langCart: state => state.language.home.manage.cart,
      langToast: state => state.language.home.toast,
      cameraName: state => {
        return state.language.current === 'en' ? cameraNameEn : cameraName
      },
      detail: state => {
        return state.language.current === 'en' ? detailEn : detail
      },
      cart: state => {
        if (
          Object.prototype.toString.call(state.user.cart) === '[object Array]'
        ) {
          return state.user.cart
        }
        return state.user.cart && state.user.cart !== 'null'
          ? JSON.parse(state.user.cart)
          : []
      }
    })
  },
  watch: {
    active (newVal) {}
  },
  data () {
    let pictures = {
      7: `${this.$cdn}images/zhijia.png`,
      1: `${this.$cdn}images/t_product.png`,
      4: `${this.$cdn}images/banner_pro.png`
    }

    return {
      pictures,
      sum: 0,
      cannotdel: {
        id: '',
        status: false
      }
    }
  },
  components: {
    vcenter
  },
  mounted () {},
  methods: {
    reduce (item) {
      if (item.goodsCount > 1) {
        this.cannotdel = {
          id: '',
          status: false
        }

        item.goodsCount--
        let params = {
          goodsId: item.goodsId,
          goodsCount: item.goodsCount
        }
        this.$store.dispatch('reduceCart', params)
      } else {
        this.cannotdel = {
          id: item.goodsId,
          status: true
        }
      }
    },
    add (item) {
      let params = {
        goodsId: item.goodsId,
        goodsCount: 1,
        skuSn: item.skuSn
      }
      this.cannotdel = {
        id: '',
        status: false
      }
      this.$store.dispatch('addCart', params)
    },
    rmItem (item) {
      this.$toast.showConfirm('warn', this.langToast['15'], () => {
        let params = {
          goodsId: item.goodsId,
          goodsCount: 0
        }
        this.$store.dispatch('reduceCart', params)
      })
    },
    toPay () {
      let skus = this.cart
      this.$emit('toPay', skus)
    },
    toEight () {
      this.$router.push({ name: 'purchase' })
      this.$bus.$emit('hideAside')
    },
    cartHandle () {
      this.$bus.$emit('hideAside')
    },
    getSum () {
      let sum = 0
      let count = 0
      this.cart.forEach(item => {
        sum += item.goodsCount * item.price
        count += item.goodsCount
      })
      return [count, sum]
    }
  }
}
</script>

<style lang="scss" scoped>
$theme-color: #1fe4dc;
$border-color: #e7e7e7;
.c-button {
  height: 50px;
  padding-top: 0;
  padding-bottom: 0;
  vertical-align: middle;
  margin-top: 10px;
  display: inline-block;
  background-color: #1fe4dc;
  text-align: center;
  cursor: pointer;
  &:first-child {
    width: 50px;
    box-sizing: border-box;
  }

  &:last-child {
    width: 150px;
    line-height: 50px;
    color: #000;
    font-size: 14px;
  }
}

.cart {
  color: #000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  font-size: 16px;
  border-bottom: 1px solid $border-color;
  .c-title {
    height: 70px;
    line-height: 70px;
  }
  i {
    color: #999;
    cursor: pointer;
  }
}
.items {
  max-height: 65vh;
  overflow: auto;
  text-align: center;
  color: #2d2d2d;
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #e7e7e7;
    padding: 5px 60px;
    min-height: 250px;
    &:last-of-type {
      border-bottom: 1px solid #e7e7e7;
    }
    img {
      width: 70px;
      vertical-align: middle;
      &:last-of-type {
        width: 100px;
        margin-top: 40px;
      }
    }
    .p-img {
      flex-shrink: 0;
      width: 225px;
    }
    .product-img {
      max-width: 70px !important;
      margin-top: 0 !important;
    }

    .tow-img {
      max-width: 86px !important;
    }
    .fix-img {
      position: relative;
    }
    .zhijia-img {
      max-width: 86px !important;
    }
    .iconfont {
      font-size: 36px;
      vertical-align: middle;
      margin: 0 0px 0 20px;
    }
    .taocan {
      text-align: left;
      font-weight: bold;
      color: #2d2d2d;
      ul {
        margin-top: 4px;
        li {
          font-size: 14px;
          font-weight: normal;
          color: #969696;
        }
      }
      .numAP-con{
        position: relative;
        .numAP {
          font-weight: normal;
          text-align: center;
          user-select: none;
          margin-top: 30px;
          span {
            font-size: 16px;
            margin: 0 10px;
          }
          i {
            cursor: pointer;
            display: inline-block;
            width: 20px;
            height: 20px;
            line-height: 10px;
            padding: 2px;
            border: 1px solid #e7e7e7;
          }
          .fobid {
            cursor: url(https://4dscene.4dage.com/new4dkk/images/forbid.png), auto;
            color: #ccc;
            background-color: #f7f8fa;
            border-color: #e6e7eb;
          }
        }
        .error-txt {
          font-weight: normal;
          font-size: 14px;
          text-align: center;
          position: absolute;
          bottom: -30px;
          left: 50%;
          transform: translateX(-50%);
          min-width: 100px;
          span {
            background: #a1f2ef;
            color: #ff0000;
            display: inline-block;
          }
        }
      }

    }
    .jiage {
      .jg-price {
        font-weight: bold;
        color: #2d2d2d;
      }
      .oper {
        margin-top: 30px;
        text-align: right;
        span {
          cursor: pointer;
          color: #a0a0a0;
          border-bottom: 1px solid #e7e7e7;
        }
      }
    }
  }

.p-info {
      border-bottom: 1px solid $border-color;
      padding: 20px 30px 20px 20px;
      min-height: 80px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      position: relative;
      >div{
        flex: 1
      }
      .p-img{
        height: 75px;
        flex: 4;
        display: inline-block;
        text-align: left;
        .pi-con{
          text-align: center;
          width: 100px;
          height: 75px;
          img {
            width: auto;
            height: 100%;
            flex-shrink: 0;
            vertical-align: middle;
          }
        }

      }
      .p-params {
        padding-left: 90px;
        vertical-align: middle;
        position: absolute;
        top: 20px;
        left: 50px;
        margin-right: 20px;
        text-align: left;
        h3 {
          font-size: 16px;
        }
        p {
          color: #ddd;
          margin-top: 5px;
        }
        ul{
          margin-top: 4px;
          li{
            font-size: 14px;
            color: #969696;
          }
        }
      }
      .numAP {
        text-align: center;
        user-select: none;
        span {
          font-size: 16px;
          margin: 0 10px;
        }
        i {
          cursor: pointer;
          display: inline-block;
          width: 20px;
          height: 20px;
          line-height: 10px;
          padding: 2px;
          border: 1px solid #e7e7e7;
        }
        .fobid{
          cursor: url(https://4dscene.4dage.com/new4dkk/images/forbid.png),auto;
          color: #ccc;
          background-color: #f7f8fa;
          border-color: #e6e7eb;
        }
      }
      .error-txt{
        font-weight: normal;
        font-size: 14px;
        text-align: center;
        position: relative;
        top: 10px;
        span{
          background: #a1f2ef;
          color: #ff0000;
          display: inline-block;
        }
      }
      .oper{
        flex: 1;
        flex-shrink: 0;
        text-align: center;
        span {
          cursor: pointer;
          color: #a0a0a0;
          border-bottom: 1px solid #e7e7e7;
        }
      }
      .p-price{
        text-align: right;
        display: inline-block;
        font-weight: bold;
        flex-shrink: 0;
      }
    }

  .no-cart {
    margin: 0 auto;
    width: 100%;
    padding-top: 40px;
    img {
      max-width: 300px;
      margin-bottom: 20px;
    }
    p {
      font-size: 24px;
      color: #a0a0a0;
      line-height: 1.5;
    }
  }
}
.jiesuan {
  text-align: right;
  margin-top: 40px;
  padding: 20px 30px 20px 20px;
  p {
    color: #a0a0a0;
    line-height: 36px;
  }
  .price {
    line-height: 40px;
    font-size: 24px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/layout/aside/temp/ctemp/list.vue